import React from "react";
import { Icon } from "armstrong-react";

import { InlineTabControl } from "./inlineTabControl";

import "./tabBox.scss";

export interface TabDefinition {
  icomoon?: string;
  className?: string;
  label: string;
  render: () => JSX.Element;
}

interface Props {
  currentTabIndex?: number;
  tabs: TabDefinition[];
  onTabChanged?: (index) => void;
}

interface State {
  tabIndex: number;
}

export default class TabBox extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      tabIndex: props.currentTabIndex || 0
    };
  }

  public componentWillReceiveProps(newProps: Props) {
    if (newProps.currentTabIndex != null && newProps.currentTabIndex != this.state.tabIndex) {
      this.setState({ tabIndex: newProps.currentTabIndex });
    }
  }

  public changeTab(index: number) {
    this.setState({ tabIndex: index });
  }

  public render() {
    let maxIndex = this.props.tabs.length;
    let currentTab = this.props.tabs[this.state.tabIndex];

    let handleTabClick = (index: number) => {
      this.setState({ tabIndex: index }, () => this.props.onTabChanged ? this.props.onTabChanged(index) : {})
    }

    return (
      <div className="tab-box">
        <InlineTabControl currentTabIndex={this.state.tabIndex} ignoreScreenSize={true} changeTab={handleTabClick}>
          {this.props.tabs.map((def, i) => (
            <div className={def.className} key={`tab-${i}`}>{def.icomoon && <Icon icon={def.icomoon} />}<span>{def.label}</span></div>
          ))}
        </InlineTabControl>

        <div className="tab-content-wrap">
          {this.props.tabs && currentTab &&
            currentTab.render()
          }
        </div>
      </div>
    )
  }
}